import { logError } from "../../helpers/ErrorHelper"

export const errorHandler = (error) => {
  if (error?.response) {
    // Errores con respuesta del servidor (4xx, 5xx)
    logError(error, error.response.status === 422 ? 0 : 2)
    
    // Solo navegar a 500 en errores críticos del servidor (5xx)
    // y no en errores de cliente (4xx) como 401, 403, 404, 422, etc.
    if (error.response.status >= 500) {
      // Solo para errores críticos del servidor
      console.error("Critical server error:", error.response)
      // Opcional: podrías mostrar un toast/modal en lugar de navegar
      return false // Deja que el componente maneje el error
    }
    
    return false // Deja que el componente maneje errores 4xx
  } else {
    // Errores de red/conexión - estos sí son críticos
    logError(error, 2)
    console.error("Network error:", error)
    // Aquí podrías mostrar un modal global de "sin conexión" 
    // en lugar de navegar a /500
    return false // Deja que el componente maneje el error
  }
}